export enum AlertType {
  QUOTE = 'quote',
  ORDER = 'order',
}
